import { render, staticRenderFns } from "./StayOnFile.vue?vue&type=template&id=760bb8a2&"
import script from "./StayOnFile.vue?vue&type=script&lang=js&"
export * from "./StayOnFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports